import Logo from "../../components/Logo";
import StepOne from "./Steps/StepOne.js";
import StepTwo from "./Steps/StepTwo.js";
import Success from "./Steps/Success.js";
import { useState, useRef, useCallback } from "react";
import { useSystem } from "../../hooks/use-system";
import LanguageSelector from "../../components/LanguageSelector";
import { defaultLanguage } from "../../constants/languages";
import { Progress } from "../../components/UI/progress";
import { CSSTransition, SwitchTransition } from "react-transition-group";

export default function Nord() {
  const { config, language } = useSystem();
  const [registerStep, setRegisterStep] = useState(0);

  const stepOneRef = useRef(null);
  const stepTwoRef = useRef(null);
  const nodeRef = registerStep === 0 ? stepOneRef : stepTwoRef;
  const [verificationRequest, setVerificationRequest] = useState(null);
  const [carrierCode, setCarrierCode] = useState(null);

  const handleVerificationRequest = useCallback((value) => {
    setVerificationRequest(value);
  }, []);

  const handleCarrierCode = useCallback((value) => {
    setCarrierCode(value);
  }, []);

  return (
    <>
      {registerStep === 2 ? (
        <div className="nord min-h-screen bg-center bg-no-repeat bg-cover relative flex flex-col">
          <Success />
        </div>
      ) : (
        <div
          className="nord min-h-screen flex flex-col-reverse sm:flex-row landscape:flex-row"
          style={{
            backgroundImage: `url(${config.background_image})`,
            backgroundColor: config.background_color,
            color: config.text_color,
            fontFamily: config.font_family,
          }}
        >
          <div className="md:w-1/2 landscape:w-1/3 bg-blue-500 justify-center items-start pt-[25%] landscape:pt-[10%] relative hidden sm:flex landscape:flex">

            <img
              src={config.featured_image}
              className="max-w-full h-auto w-[80%] landscape:w-[90%]"
              alt="Featured"
            />
          </div>
          <div className="md:w-1/2 landscape:w-2/3 flex flex-col justify-center items-start px-4 md:px-[120px] landscape:px-6 bg-white landscape:min-h-screen">
            <div className="flex items-center justify-between w-full landscape:mb-2 landscape:px-4">
              <div className="w-1/3 flex justify-center items-center"></div>
              <div className="w-1/3 flex justify-center items-center">
                {config.logo_url && !config.logo_under_button && (
                  <img
                    src={config.logo_url}
                    alt={"Logo"}
                    id="Logo"
                    className={`${
                      config.logo_size === "Small" ? " max-w-[200px]" : ""
                    } landscape:max-w-[100px]`}
                  />
                )}
              </div>
              <div className="w-1/3 flex justify-center items-center">
                <LanguageSelector
                  supportedLanguages={config.supported_languages}
                />
              </div>
            </div>
            <div className="w-full flex justify-center items-center landscape:mb-1 landscape:px-4">
              <h2
                className="text-center font-bold lg:text-3xl md:text-2xl text-xl landscape:text-base leading-snug"
                style={{
                  color: config.titles_color || "#000",
                }}
              >
                {config.texts?.[language || defaultLanguage]?.[registerStep]
                  ?.title || ""}
              </h2>
            </div>
            {config.texts?.[language || defaultLanguage]?.[registerStep]
              ?.sec_title && (
              <div className="w-full flex justify-center items-center landscape:mb-0 mb-1 landscape:px-4">
                <p
                  className="text-md text-sm md:text-lg landscape:text-xs"
                  style={{
                    color: config.titles_color || "#000",
                  }}
                >
                  {
                    config.texts?.[language || defaultLanguage]?.[registerStep]
                      ?.sec_title
                  }
                </p>
              </div>
            )}

            <div className="w-full flex flex-col items-center justify-center landscape:mb-0">
              <div className="w-full flex md:flex-row lg:flex-row md:justify-center items-center gap-8 mx-auto max-w-md landscape:max-w-sm landscape:gap-3 landscape:px-6">
                <div className={`${registerStep === 0 ? 'w-2/3 landscape:w-2/3' : 'w-1/3 landscape:w-1/3'} flex flex-col gap-2 justify-center items-start`}>
                  <p
                    className="text-[10px] landscape:text-[9px] text-wrap text-left m-0"
                    style={{
                      color: config.text_color || "#000",
                    }}
                  >
                    {config.texts?.[language || defaultLanguage]?.[registerStep]?.step_one_text}
                  </p>
                </div>
                <div className={`${registerStep === 0 ? 'w-1/3 landscape:w-1/3' : 'w-2/3 landscape:w-2/3'} flex flex-col gap-2 justify-center items-start`}>
                  <p
                    className="text-[10px] landscape:text-[9px] text-wrap text-left m-0"
                    style={{
                      color: config.text_color || "#000",
                    }}
                  >
                    {config.texts?.[language || defaultLanguage]?.[registerStep]?.step_two_text}
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full flex flex-col items-center justify-center mt-2 landscape:mt-0">
              <div className="w-full flex md:flex-row lg:flex-row md:justify-center items-center gap-8 mx-auto max-w-md landscape:max-w-sm landscape:gap-3 landscape:px-6">
                <div className={`${registerStep === 0 ? 'w-2/3 landscape:w-2/3' : 'w-1/3 landscape:w-1/3'} flex flex-col gap-2 justify-center items-start`}>
                  <Progress
                    height="h-2 landscape:h-2"
                    value={registerStep === 0 ? 60 : 100}
                  />
                </div>
                <div className={`${registerStep === 0 ? 'w-1/3 landscape:w-1/3' : 'w-2/3 landscape:w-2/3'} flex flex-col gap-2 justify-center items-start`}>
                  <Progress
                    className="w-full"
                    height="h-2 landscape:h-2"
                    value={registerStep === 0 ? 0 : 60}
                  />
                </div>
              </div>
            </div>
            <div className="w-full flex justify-center items-center relative mt-3 sm:hidden landscape:hidden">
              <img
                src={config.featured_image}
                className="max-w-full h-auto"
                alt="Featured"
              />
            </div>
            <div className="w-full items-center justify-center landscape:flex-1">
              <SwitchTransition mode="out-in">
                <CSSTransition
                  key={registerStep}
                  classNames="fade"
                  nodeRef={nodeRef}
                  addEndListener={(done) => {
                    nodeRef.current.addEventListener(
                      "transitionend",
                      done,
                      false
                    );
                  }}
                  timeout={1000}
                >
                  <div ref={nodeRef}>
                    {registerStep === 0 ? (
                      <StepOne
                        setStep={setRegisterStep}
                        config={config}
                        language={language}
                        handleVerificationRequest={handleVerificationRequest}
                        handleCarrierCode={handleCarrierCode}
                      />
                    ) : registerStep === 1 ? (
                      <StepTwo
                        setStep={setRegisterStep}
                        config={config}
                        language={language}
                        verificationRequest={verificationRequest}
                        carrierCode={carrierCode}
                      />
                    ) : null}
                  </div>
                </CSSTransition>
              </SwitchTransition>
            </div>

            <div className="mt-3 landscape:mt-1 text-center w-full flex-col mx-auto items-center justify-center max-w-md landscape:max-w-sm">
              <div
                className="font-medium text-[9px] landscape:text-[7px] text-justify leading-[12px] landscape:leading-[9px] flex flex-col gap-2 w-full"
                dangerouslySetInnerHTML={{
                  __html:
                    config.texts?.[language || defaultLanguage]?.[registerStep]
                      ?.paragraph_under_button || "",
                }}
              ></div>
              <div className="flex flex-col items-center">
                {config.flow_icon && (
                  <div className="w-full my-1 landscape:my-0">
                    <img
                      src={config.flow_icon}
                      alt="Flow Icon"
                      className="mx-auto landscape:max-h-4"
                    />
                  </div>
                )}
                <div className="w-full flex flex-wrap justify-center text-sm landscape:text-[10px] text-center space-x-4 landscape:space-x-1">
                  <a href={config.terms_url} className="text-gray-700">
                    {config.translations?.[language || defaultLanguage]?.terms}
                  </a>

                  {config.policy_url && (
                    <>
                      <span className="text-light">|</span>
                      <a
                        href={config.policy_url}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: config.titles_color }}
                        className="text-gray-700"
                      >
                        {
                          config.translations?.[language || defaultLanguage]
                            ?.policy
                        }
                      </a>
                    </>
                  )}

                  {config.about_text && (
                    <>
                      <span className="text-light">|</span>
                      <a
                        href={config.about_url}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: config.titles_color }}
                        className="text-gray-700"
                      >
                        {
                          config.translations?.[language || defaultLanguage]
                            ?.about
                        }
                      </a>
                    </>
                  )}

                  {config.disclaimer_text && (
                    <>
                      <span className="text-light">|</span>
                      <a
                        href={config.disclaimer_url}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: config.titles_color }}
                        className="text-gray-700"
                      >
                        {
                          config.translations?.[language || defaultLanguage]
                            ?.disclaimer
                        }
                      </a>
                    </>
                  )}

                  {config.contact_us_text && (
                    <>
                      <span className="text-light">|</span>
                      <a
                        href={config.contact_us_url}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: config.titles_color }}
                        className="text-gray-700"
                      >
                        {
                          config.translations?.[language || defaultLanguage]
                            ?.contact
                        }
                      </a>
                    </>
                  )}
                </div>
                {config.bottom_text &&
                    <div id={'bottomText'} className="landscape:text-[10px]" dangerouslySetInnerHTML={{__html: config.translations?.[language || defaultLanguage]?.bottom_text}}></div>
                }
                <div className="flex items-center justify-center my-3 landscape:my-1">
                  <span className="landscape:text-[10px]">Powered by</span> &nbsp;
                  <a target="_blank" style={{textDecoration: "none", color: "inherit", fontWeight: "bold"}} className="landscape:text-[10px]">DCB <span style={{background: "linear-gradient(92.32deg, rgb(117, 56, 240) -3.12%, rgb(242, 51, 231) 100.39%) text", WebkitTextFillColor: "transparent"}}>CHECKOUT</span></a>
                </div>

              </div>
            </div>
          </div>

          {config.logo_url && config.logo_under_button && (
            <Logo
              logo_url={config.logo_url}
              logo_position={config.logo_position}
              logo_size={config.logo_size}
              classes="bottom"
            />
          )}
        </div>
      )}
    </>
  );
}
